module.exports = __webpack_public_path__ + "img/plague_bearer_small.c66145be.png";